export const reportReasons = [
  { key: "render_error", value: "Not rendered correctly" },
  { key: "spelling_error", value: "Spelling/Grammar mistake" },
  { key: "option_error", value: "Incorrect options/answers" },
  {key:"other_error", value: "Other" }
];
